import Loadable from "../../../components/Loadable";

const DaftarUlang = Loadable(() => import("./DaftarUlang"));

export default {
  DaftarUlang,
};
